export const expEmail = /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
export const expName = /^[A-Z 0-9._+-]+$/i;
export const expNumeric = /^[0-9._+-]+$/i;
export const expAlphaNumeric = /^[A-Z0-9._+-]+$/i;
export const expSpecialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const expUperCase = /[A-Z]/;
// export const expDecimalPositive = /^\d+(\.\d{1,2})?$/;